import { render, staticRenderFns } from "./security_training_promo_banner.vue?vue&type=template&id=62edcb20&"
import script from "./security_training_promo_banner.vue?vue&type=script&lang=js&"
export * from "./security_training_promo_banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports